// Where the app should go when it is opened from outside: a tapped
// notification (data.link = '/jobs/42') or an App Link
// (https://nano.nanoutilities.co.uk/jobs/42). Both can arrive before anyone
// is signed in, or while the app is still starting, so the path waits here
// until the signed-in app is ready to show it (see OpenLinks).
import { App as CapApp } from '@capacitor/app';
import { isNative } from '../config.js';

export const LINK_HOST = 'nano.nanoutilities.co.uk';
const KEY = 'nu.pendingLink';
const listeners = new Set();

// Only our own paths, never another site. /go/<screen> is <screen>: links
// for engineers use /go/ so the app claims them without a release per module.
export function pathFromLink(link) {
  if (typeof link !== 'string' || !link) return null;
  let path = null;
  if (link.startsWith('/') && !link.startsWith('//')) path = link;
  else {
    try {
      const u = new URL(link);
      if (u.protocol === 'https:' && u.hostname === LINK_HOST) path = `${u.pathname}${u.search}${u.hash}` || '/';
    } catch { /* not a URL */ }
  }
  return path ? unGo(path) : null;
}

export function unGo(path) {
  return path === '/go' || path.startsWith('/go/') || path.startsWith('/go?') ? (path.slice(3) || '/').replace(/^(?!\/)/, '/') : path;
}

export function openLink(link) {
  const path = pathFromLink(link);
  if (!path) return;
  // Kept across the sign-in redirect, which reloads the app.
  try { sessionStorage.setItem(KEY, path); } catch { /* private mode: still delivered below if mounted */ }
  listeners.forEach((fn) => fn(path));
}

export function takePendingLink() {
  try {
    const p = sessionStorage.getItem(KEY);
    sessionStorage.removeItem(KEY);
    return p;
  } catch { return null; }
}

export function onLink(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

// Called once at start-up, before React renders, so a link that launched the
// app is not missed.
export async function startLinkListeners() {
  if (!isNative) return;
  CapApp.addListener('appUrlOpen', (e) => openLink(e.url));
  const launch = await CapApp.getLaunchUrl().catch(() => null);
  if (launch?.url) openLink(launch.url);
}
